import React from 'react';
import Navbar from './Navbar';
import './IntroPage.css';      // for navbar styling
import './MeetTheTeam.css';    // for team page styles

const MeetTheTeam = () => (
  <>
    <Navbar />

    <div className="intro-container">
      <h2>Meet the Team</h2>

      <div className="team-member">
        <h3>Abhinav Sattur</h3>
        <h4>President and Founder of VBADI | High School Student | Environmental Enthusiast| Justice Driven</h4>
        <p>
        Abhinav Sattur is a dedicated and forward-thinking high school student, currently serving as the president of VBADI. 
        He is characterized  for his leadership skills and a deep commitment to environmental issues, 
        Abhi works actively on initiatives that promote sustainability and raise awareness about pressing environmental challenges within his own community by starting his own blog to raise environmental awareness globally and an environmentally focused club at his school.
        His passion for the environment is matched by his enthusiasm for educating others . 
        Abhi aims to combine his love for teaching and the environment to inspire others, leading by example to create a more resilient, greener future..
        </p>
      </div>

      {/* <div className="team-member">
        <h3>Rachita Lingala</h3>
        <h4>CEO of VBADI | Software Engineer | Environmental Advocate | Advocate for Global Equity</h4>
        <p>
          Rachita Lingala is a visionary leader and the CEO of VBADI. As an engineer by profession, she combines her 
          technical expertise with a deep compassion for environmental sustainability 
          and global equity. With a strong belief in the power of education and access 
          to opportunities, Rachita works relentlessly to promote environmental 
          consciousness and social justice across the world. She is committed to 
          teaching, raising awareness, and driving initiatives that ensure a better, 
          more equitable future for all communities, regardless of their background 
          or location. Her leadership is focused on fostering innovative solutions that 
          bridge gaps in health, education, and environmental stewardship.
        </p>
      </div> */}

<div className="team-member">
  <h3>Educators</h3>

  <p>
    <strong>Rachita Lingala</strong><br />
    Currently teaches online to students at Aim For Seva Free Girls Hostel in
    Mandapali, Nizambad.
  </p>

  <p>
    <strong>Sudhakar Sattur</strong><br />
    Currently teaches online to students at Smt & Sri Satoor Rajasri &
    Rajalingam Goud AIM for Seva Chatralayam for Boys in Chinnadarpally Village,
    Mahabubnagar District.
  </p>
</div>
    </div>
  </>
);

export default MeetTheTeam;
